// Copyright (c) 2022 WiseTime. All rights reserved.

import { concat, Observable, of } from "rxjs"
import { Action } from "redux"
import { t } from "@lingui/macro"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as Actions from "../actions"
import { grpc } from "../../../app/rpc/executor"
import { postExpectationsClient } from "../../../app/rpc/client"
import * as Slice from "../slices/stats"
import {
  ListLeavesRequest,
  ListLeavesResponse
} from "../../../generated/legebill/site/postexpectation/v4/post_expectation_pb"
import { showSnackBar } from "../../snackbar/actions"

type CreateLeaveRpc = (request: ListLeavesRequest) => Observable<ListLeavesResponse>

export const listLeaves = (listLeavesRpc: CreateLeaveRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.listLeaves.match),
      mergeMap(action => of(action.payload)
        .pipe(
          mergeMap(listLeavesRpc),
          map(t => t.toObject().leavesList),
          map(Slice.setLeaveList),
          catchError(() => concat(
            of(Actions.listLeavesErrored()),
            of(showSnackBar({
              message: t({ id: "msg_list_leaves_failed", message: "Failed to load leaves. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com." }),
              messageType: "ERROR",
            }))
          )),
        )
      ),
    )

const listLeavesRpc = (request: ListLeavesRequest): Observable<ListLeavesResponse> =>
  grpc(() => postExpectationsClient.listLeaves(request, null))

export default listLeaves(listLeavesRpc)
